import React from 'react';
import { MessageCircle } from 'lucide-react';
import { companyInfo } from '../utils/mockData';

const WhatsAppButton = () => {
  return (
    <a
      href={`https://wa.me/${companyInfo.whatsapp.replace(/\D/g, '')}?text=Hello! I'm interested in your electrical solutions.`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-sticky bg-green-600 hover:bg-green-700 text-white p-4 rounded-full shadow-2xl flex items-center gap-2 group"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle size={28} className="group-hover:rotate-12 transition-transform" />
      <span className="hidden md:inline font-semibold pr-2">WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
